import { Component, Prop, Vue } from 'vue-property-decorator';
import { DxScheduler, DxResource } from 'devextreme-vue/scheduler';
import DxButton from 'devextreme-vue/button';
import es from 'devextreme/localization/messages/es.json';
import { locale, loadMessages } from 'devextreme/localization';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import { Evento } from '@/shared/dtos/evento';
import { API } from '@/shared/api';
import { itiHttpService, itiMessageService } from '@/iti-core-vue';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { LoadOptions } from 'devextreme/data/load_options';
import { confirm } from 'devextreme/ui/dialog';
import Leyenda from '../leyenda/leyenda.vue';
import { Roles } from '../../shared/roles';
import collaborativeAreaModule from '@/store/modules/collaborative-area.module';

@Component({
    components: {
        DxScheduler,
        DxResource,
        DxButton,
        Leyenda,
    },
})
export default class Calendario extends Vue {
    public colors: string[] = ['#1AC778', '#E16824', '#22B4E3', '#D2C11A', '#D27E1A',
        '#6D1FBB', '#D23C55', '#E8B795', '#8EE885', '#85E8E8',
        '#9985E8', '#E885C5', '#E61D1D', '#225E9E', '#9E2222',
        '#4F2BD5', '#D2D52B', '#7676B1', '#9F2020', '#209F52'];
    public asignedColors: any = [];
    public collaborativeAreas: any[] = [];
    public store!: DataSource;
    public canEdit: boolean = false;

    public setStore(collaborativeAreaId: string) {
        this.store = new DataSource({
            store: new CustomStore({
                load: (options: LoadOptions) => {
                    var ambitId = collaborativeAreaId;
                    if (collaborativeAreaId == undefined)
                        ambitId = '-1';
                    return itiHttpService.get(API.eventos + '/GetEvents?ambitId=' + ambitId).then((response: any[]) => {
                        return this.setColors(response);
                    })
                        .catch(() => itiMessageService.toast(this.$tc('schedule.show'), itiMessageService.TypeError));
                },
                insert: (value) => {
                    const evento: Evento = new Evento(value);
                    evento.ambitId = Number.parseInt(collaborativeAreaId);
                    evento.color = '#1AC778';
                    evento.id = 0;
                    evento.completed = null;
                    if (value.tarea) {
                        evento.completed = false;
                    }
                    return itiHttpService.post(API.eventos + "/Post", evento.toJson())
                        .catch(() => itiMessageService.toast(this.$tc('schedule.create'), itiMessageService.TypeError));

                },
                update: (key, value) => {
                    const evento: Evento = new Evento(value);
                    return itiHttpService.put(API.eventos + "/Put", evento.toJson(), false, false, false)
                        .catch(() => itiMessageService.toast(this.$tc('schedule.upload'), itiMessageService.TypeError));
                },
                remove: (value) => {
                    return itiHttpService.delete(API.eventos + '/Delete?id=' + value.id, '');
                }
            }),
        });
    }

    public created() {
        this.GetRoles(this.$route.params.collaborativeAreaId);
        this.setStore(this.$route.params.collaborativeAreaId);
        locale('es');
        loadMessages(es);
        this.getDomEvents();
        if (this.$route.params.collaborativeAreaId != undefined)
            collaborativeAreaModule.getCollaborativeAreaById(Number.parseInt(this.$route.params.collaborativeAreaId));
    }

    public getDomEvents() {
        const observer = new MutationObserver((mutations) => {
            this.scheduler.repaint();
        });

        observer.observe(document.childNodes[1], {
            attributes: true,
            childList: true,
            characterData: true
        });
    }

    scheduler!: any;
    public mounted() {
        this.scheduler = (this.$refs['schedule'] as DxScheduler).instance;
        window.addEventListener('resize', this.windowResizeHandler);
    }

    windowResizeHandler(e: any) {
        this.scheduler.repaint();
    }

    public destroyed() {
        window.removeEventListener('resize', this.windowResizeHandler);
    }

    public getColorApointment(id: Number) {
        return '#1AC778';
    }

    public setColors(events: any[]) {
        events.forEach((event: any) => {
            var colorIndex = this.asignedColors.findIndex((element: any) => element == event.ambitId);
            if (colorIndex != -1)
                event.color = this.colors[colorIndex];
            else {
                this.asignedColors.push(event.ambitId);
                event.color = this.colors[this.asignedColors.length - 1];
                itiHttpService.get(API.collaborativeArea + '/(' + event.ambitId + ')', '', false, false, false).then((res: any) => {
                    this.collaborativeAreas.push({ id: res.id, name: res.name });
                });
            }
        });
        return events;
    }

    public GetRoles(ambitId: any) {
        if (ambitId != undefined)
            itiHttpService.get(API.collaborativeArea + '/GetRoleInCollaborativeArea?ambitId=' + ambitId)
                .then((response: any[]) => {
                    this.canEdit = response.includes(Roles.OwnerCollaborativeArea)
                        || response.includes(Roles.CollaboratorCollaborativeArea);
                    this.scheduler.repaint();
                });
    }

    public getColor(color: string) {
        return 'background-color: ' + color;
    }

    public getDate(date: Date) {
        return date.toString().split('T')[0].substring(8, 10)
            + ' del ' + date.toString().split('T')[0].substring(5, 7)
            + ' ' + date.toString().split('T')[1].substring(0, 5);
    }

    public get editing() {
        return {
            allowAdding: this.canEdit && this.editable,
            allowDeleting: this.canEdit,
            allowUpdating: this.canEdit,
            allowResizing: true,
            allowDragging: this.canEdit
        }
    }

    public stopPropagation(e: any) {
        e.stopPropagation();
    }

    public blockViewResumen(e: any) {
        if (!this.editable) {
            e.stopPropagation();
        }
    }

    public completEvent(value: any, send: boolean) {
        if (send) {
            const evento: Evento = new Evento(value);
            evento.completed = value.completed;
            itiHttpService.put(API.eventos + "/Put", evento.toJson(), false, false, false)
                .catch(() => itiMessageService.toast(this.$tc('schedule.upload'), itiMessageService.TypeError));
        }

    }

    public get editable() {
        return this.$route.params.collaborativeAreaId != undefined;
    }

    public deleteAppointment(value: any) {
        let result = confirm("<i>" + this.$tc('schedule.delete-confirm') + "</i>", "Confirmar");
        result.then((result: boolean) => {
            if (result) itiHttpService.delete(API.eventos + '/Delete?id=' + value.id, '')
                .then(() => { this.store.reload(); })
                .catch(() => itiMessageService.toast(this.$tc('schedule.delete'), itiMessageService.TypeError))
        });
    }

    public get currentDate() {
        return Date.now();
    }

    public get dataSource() {
        return this.store;
    }

    public get views() {
        return ['month', 'agenda'];
    }

    public get colorsArray() {
        return this.colors;
    }

    public get asignedColorsArray() {
        return this.asignedColors;
    }

    public get showLeyenda() {
        return !this.editable;
    }

    public onAppointmentFormOpening(e: any) {
        e.popup.option('showTitle', true);
        e.popup.option('title', e.appointmentData.text ?
            e.appointmentData.text :
            'Crear nuevo evento');

        var toolbar = e.popup.option('toolbarItems');

        var deleteButton = Object.assign({}, toolbar[0]);
        deleteButton.onClick = () => this.deleteAppointment(e.appointmentData);
        if (!this.editable || !this.canEdit) {
            deleteButton.options = { visible: false };
        }
        else {
            toolbar[0].options = { text: 'Guardar' };
            deleteButton.options = { text: 'Borrar' };
        }
        if (e.appointmentData.text == undefined)
            deleteButton.options = { visible: false };

        toolbar.push(deleteButton);

        var guradar = toolbar[0];
        toolbar[0] = deleteButton;
        toolbar[2] = guradar;
        e.popup.option('toolbarItems', toolbar);

        const showType = e.appointmentData.text == undefined;
        const showCompleted = e.appointmentData.text != undefined && e.appointmentData.completed != null;
        const form = e.form;
        let mainGroupItems = form.itemOption('mainGroup').items;
        let recurrenceGroup = form.itemOption('recurrenceGroup').items;

        if (!mainGroupItems.find(function (i: any) { return i.dataField === "tarea" })) {
            mainGroupItems.push({
                label: { text: "Tarea" },
                editorType: "dxSwitch",
                dataField: "tarea",
                visible: showType,
            });
        }
        else
            mainGroupItems[6].visible = showType;
        if (!mainGroupItems.find(function (i: any) { return i.dataField === "completed" })) {
            mainGroupItems.push({
                label: { text: "Completar" },
                editorType: "dxCheckBox",
                dataField: "completed",
                visible: showCompleted,
            });
        }
        else {
            mainGroupItems[7].visible = showCompleted;
        }

        if (!this.editable || !this.canEdit) {
            mainGroupItems[0].disabled = true;
            mainGroupItems[1].disabled = true;
            mainGroupItems[2].disabled = true;
            mainGroupItems[3].disabled = true;
            mainGroupItems[4].disabled = true;
            mainGroupItems[5].disabled = true;
            mainGroupItems[6].disabled = true;
            mainGroupItems[7].disabled = true;
            recurrenceGroup[0].disabled = true;
        }

        form.itemOption('mainGroup', 'items', mainGroupItems);
        form.itemOption('recurrenceGroup', 'items', recurrenceGroup);

    }

    repaint: boolean = true;
    onContentReady(e: any) {
        if (this.repaint) {
            this.repaint = false;
            e.component.repaint();
        }
    }

    public backToHome() {
        this.$router.back();
    }

    public goToAreaHome() {
        this.$router.push({ name: 'CollaborativeAreaDetails', params: { id: this.collaborativeArea.id.toString() } });
    }

    public get collaborativeArea() {
        return collaborativeAreaModule.selectedCollaborativeArea;
    }
}
